import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  InputSignal,
  OutputEmitterRef,
  computed,
  Signal,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsButtonVariants, DsTooltipPosition, Icons } from '@levelaccess/design-system';

import { SharedModule } from '../../shared/shared.module';
import { TranslateService } from '../../translate/translate.service';

@Component({
  selector: 'app-confidential-scanning-switch',
  templateUrl: './confidential-scanning-switch.component.html',
  styleUrls: ['./confidential-scanning-switch.component.scss'],
  imports: [CommonModule, SharedModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfidentialScanningSwitchComponent {
  public readonly value: InputSignal<boolean> = input<boolean>(false);
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly tooltip: InputSignal<string | undefined> = input<string | undefined>(undefined);
  public readonly valueChange: OutputEmitterRef<boolean> = output<boolean>();

  public readonly DsTooltipPosition: typeof DsTooltipPosition = DsTooltipPosition;
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  public readonly Icons: typeof Icons = Icons;
  private readonly translate: TranslateService = inject(TranslateService);

  public readonly tooltipKey: Signal<string | null> = computed(() => {
    if (!this.disabled() || !this.tooltip()) {
      return null;
    }
    return this.tooltip();
  });

  public readonly tooltipText: Signal<string | null> = computed(() => {
    const key = this.tooltipKey();
    return key ? this.translate.instant(key) : null;
  });

  public readonly hasTooltip: Signal<boolean> = computed(() => Boolean(this.tooltipKey()));

  public readonly ariaDescribedBy: Signal<string> = computed(() => {
    return this.hasTooltip()
      ? 'confidential-scanning-description confidential-scanning-heading-tooltip'
      : 'confidential-scanning-description';
  });

  public onValueChange(newValue: boolean): void {
    if (!this.disabled()) {
      this.valueChange.emit(newValue);
    }
  }
}
